'use strict';

export default class ProductDetailFeedback {
	constructor() {
		this.rating = document.querySelector('[data-product-rating]');
		if (!this.rating) return false;
		this._matchHTML();
		this._rating();
	}

	_matchHTML(){
		this.ratingCount = this.rating.querySelector('[data-product-rating-count]');
		this.stars = [...this.rating.querySelectorAll('.rating__control')];
	}

	_rating(){
		if (!this.rating) return false;

		let action = this.rating.dataset.targetAction,
			data = this.rating.dataset.ajaxParams,
			that = this;

		if (data) data = JSON.parse(data.split("'").join('"'));

		if (typeof BX.bitrix_sessid !== "undefined") { 
			data.sessid = BX.bitrix_sessid();
		}

		this.stars.forEach(star => {
			star.addEventListener('change', e => {
				if (star.checked){
					data.rating = star.value;
					$.ajax({
						type: 'POST',
						url: action,
						data: data,
						dataType: 'json',
						success: function(res) {
							that.ratingCount.innerHTML = res.value;
							that.rating.classList.add('rating--readonly');
						}
					});
				}
			});
		})
	}
}
